<template>
    <div class="post-collapse p-2">
        <div @click="handleToggleCollapsePost" class="wrap-name-item display-flex-center">
            <span class="name-post">{{ item.name }}</span>
            <div class="icon-area" v-if="item.listDocumentClassSchool.length > 0">
                <img class="icon-down-arrow" v-if="!item.isCollapse" src="@/assets/img/icon-down-arrow.png" />
                <img class="icon-up-arrow" v-else src="@/assets/img/icon-up-arrow.png" />
            </div>
        </div>
        <div class="pl-2">
            <slot name="lecture">
            </slot>
        </div>
    </div>
</template>
<script>

export default{
    props:{
        item:{
            type:Object,
            default:{}
        },
        indexChapter:{
            type: Number,
            default: null
        },
        indexElectronicLecture :{
            type: Number,
            default: null
        },
    },
    data(){
        return{
            
        }
    },
    methods:{
        handleToggleCollapsePost(){
            this.$emit('handleToggleCollapsePost',this.item, this.indexChapter, this.indexElectronicLecture)
        },
    }
}
</script>
<style lang="scss" scoped>
.wrap-name-item{
    cursor: pointer;
    border-bottom: 1px solid #dee2e6;
}
</style>